import { render } from "./WishList.vue?vue&type=template&id=b516a29c&scoped=true"
import script from "./WishList.vue?vue&type=script&lang=js"
export * from "./WishList.vue?vue&type=script&lang=js"

import "./WishList.vue?vue&type=style&index=0&id=b516a29c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b516a29c"]])

export default __exports__